export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            关于6080
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            了解6080新视觉影视的初心与坚持
          </p>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-10">
          <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-start">
            <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
              <i className="ri-movie-2-line text-3xl md:text-4xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                <strong className="text-foreground-900">6080影视</strong>源于6080新视觉影视多年积累的影视资源与技术沉淀，
                致力于为全球华语观众提供一个<strong className="text-foreground-900">完全免费、高清流畅、无需注册</strong>的电影在线观看平台。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                我们相信好电影不应该有门槛。无论是院线最新大片、网络热门电影，还是被遗忘的经典老片，
                6080影视都为你一一收录。依托持续优化的不缓冲播放技术与每日更新的资源体系，
                让每一位影迷随时随地畅享高清电影大全。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                从6080新视觉影视到如今的全新平台，不变的是对观影品质的执着和对用户零门槛体验的坚持。
                未来我们将继续扩充片库、提升画质，让6080影视成为你观影的首选入口。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}